module.exports = __webpack_public_path__ + "static/media/google-play-badge.d0f7c5cd.png";